export default __webpack_public_path__ + "static/media/77.6228b2c9.png";